import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/CheckCircle';
import { createEditorState } from 'medium-draft';
import { FormattedMessage } from 'react-intl';
import getVideoId from 'get-video-id';
import AppContext from '../../../context';
import Audio from '../../lessonDetails/Audio/Audio';
import s from './CoursePodcastItem.scss';
import isLoggedIn from '../../../helpers/checkAuth';
import LessonTextContent from '../../lessonDetails/Text/LessonTextContent';
import LessonReviewModal from '../../lessonDetails/LessonReviewModal/LessonReviewModal';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import * as courseDetailsActions from '../../../actions/courseDetails';
import * as podcastLessonActions from '../../../actions/podcastLesson';
import messages from '../../lessonDetails/lessonDetailsMessages';
import decorators from '../../lessonDetails/Text/decorators';
import convertImages from '../../lessonDetails/Text/convertImages';
import { convertRichEditorContentToHtml, getImagesFromDraftJS, isPodcastLessonMissingAudio } from '../../../helpers';
import LessonSources from '../../lessonDetails/LessonSources/LessonSources';
import Video from '../../lessonDetails/Video/Video';
var CoursePodcastItem = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    course: state.courseDetails.course,
    lesson: state.lessonDetails.lesson,
    courseWasReset: state.courseDetails.courseWasReset,
    playPodcastAudio: state.podcastLesson.playPodcastAudio,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson
  };
}, function (dispatch) {
  return bindActionCreators({
    updateState: lessonDetailsActions.updateState,
    completeLesson: lessonDetailsActions.completeLesson,
    getCourseBySlug: courseDetailsActions.getCourseBySlug,
    resetLesson: lessonDetailsActions.reset,
    setPlayPodcastAudio: podcastLessonActions.setPlayPodcastAudio
  }, dispatch);
}), _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CoursePodcastItem, _React$Component);
  var _super = _createSuper(CoursePodcastItem);
  function CoursePodcastItem(props, context) {
    var _this;
    _classCallCheck(this, CoursePodcastItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onEditorChange", function (editorState, callback) {
      _this.setState({
        editorState: editorState
      }, function () {
        if (callback) {
          callback();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setAudioEnded", function (isAudioEnded) {
      _this.setState({
        isAudioEnded: isAudioEnded
      });
    });
    _defineProperty(_assertThisInitialized(_this), "complete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, _this$props$lesson, lessonId, lessonSlug, _this$props$course, courseId, courseSlug, completeLesson, getCourseBySlug, auth, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, _this$props$lesson = _this$props.lesson, lessonId = _this$props$lesson._id, lessonSlug = _this$props$lesson.slug, _this$props$course = _this$props.course, courseId = _this$props$course._id, courseSlug = _this$props$course.slug, completeLesson = _this$props.completeLesson, getCourseBySlug = _this$props.getCourseBySlug, auth = _this$props.auth;
            if (!(!courseId || !isLoggedIn(auth))) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", true);
          case 3:
            _context.next = 5;
            return completeLesson({
              lessonId: lessonId,
              courseId: courseId,
              courseSlug: courseSlug
            });
          case 5:
            result = _context.sent;
            if (!_.get(result, 'error')) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", false);
          case 8:
            _context.next = 10;
            return _this.context.fetch("/api/lessons/by-slug/".concat(lessonSlug, "?courseId=").concat(courseId));
          case 10:
            _context.next = 12;
            return getCourseBySlug(courseSlug);
          case 12:
            return _context.abrupt("return", true);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "showLessonReviewContent", function () {
      _this.setState({
        showLessonReviewModal: true
      });
      if (_this.state.isAudioEnded) {
        _this.props.cancelGoToNextLesson();
      } else {
        _this.props.setPlayPodcastAudio(false);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeLessonReviewContent", function () {
      _this.setState({
        showLessonReviewModal: false
      });
      if (!_this.state.isAudioEnded) _this.props.setPlayPodcastAudio(true);
    });
    _this.completePromise = null;
    _this.completeOnce = function () {
      if (!_this.completePromise) {
        _this.completePromise = Promise.resolve(_this.complete()).then(function (isCompleted) {
          if (!isCompleted) _this.completePromise = null;
          return isCompleted;
        })["catch"](function (error) {
          _this.completePromise = null;
          throw error;
        });
      }
      return _this.completePromise;
    };
    if (!_.get(props, 'lesson._id')) {
      return _possibleConstructorReturn(_this);
    }
    var isContentHasBigImages = !!_.find(_.get(props, 'lesson.content.entityMap', []), function (elem) {
      return _.get(elem, 'type') === 'IMAGE' && (parseInt(_.get(elem, 'data.width', 0), 10) > 70 || !_.includes(['right', 'left'], _.get(elem, 'data.alignment')));
    });
    var newContent = convertImages({
      cloudfrontUrl: context.cloudfrontUrl
    })(_.get(props, 'lesson.content'));
    var newSources = _.cloneDeep(_.get(props, 'lesson.sources'));
    var _editorState = createEditorState(newContent, decorators);
    var editorStateContent = _editorState && _editorState.getCurrentContent();
    var imageContent = getImagesFromDraftJS(_.get(props, 'lesson.content'));
    var isTextExist = editorStateContent && editorStateContent.hasText() && !!editorStateContent.getPlainText().trim().length || !!_.get(imageContent, 'length');
    var convertedSourcesData = convertRichEditorContentToHtml(newSources, context.cloudfrontUrl);
    _this.state = {
      isContentHasBigImages: isContentHasBigImages,
      isTextExist: isTextExist,
      editorState: _editorState,
      showLessonReviewModal: false,
      isAudioEnded: false,
      isSourcesExist: convertedSourcesData.isTextExist,
      sourcesHTML: convertedSourcesData.contentHTML,
      posterVimeo: ''
    };
    return _this;
  }
  _createClass(CoursePodcastItem, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var urlVideoVimea, _ref2, service, posterVimeo, vimeoRes, vimeoResJson;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              urlVideoVimea = _.get(this.props, 'lesson.youtubeVideoUrl');
              _ref2 = urlVideoVimea ? getVideoId(urlVideoVimea) : {}, service = _ref2.service;
              posterVimeo = '';
              if (!(service === 'vimeo')) {
                _context2.next = 18;
                break;
              }
              _context2.prev = 4;
              _context2.next = 7;
              return fetch("https://vimeo.com/api/oembed.json?url=".concat(encodeURI(urlVideoVimea)));
            case 7:
              vimeoRes = _context2.sent;
              _context2.next = 10;
              return vimeoRes.json();
            case 10:
              vimeoResJson = _context2.sent;
              posterVimeo = vimeoResJson.thumbnail_url;
              this.setState({
                posterVimeo: posterVimeo
              });
              _context2.next = 18;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](4);
              console.error(_context2.t0);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 15]]);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        lesson = _this$props2.lesson,
        courseWasReset = _this$props2.courseWasReset,
        playPodcastAudio = _this$props2.playPodcastAudio,
        openedPodcastLesson = _this$props2.openedPodcastLesson,
        lessonItem = _this$props2.lessonItem,
        goToNextLesson = _this$props2.goToNextLesson,
        setPlayPodcastAudio = _this$props2.setPlayPodcastAudio,
        auth = _this$props2.auth,
        course = _this$props2.course,
        isCompleted = _this$props2.isCompleted;
      var _this$state = this.state,
        contentLength = _this$state.contentLength,
        isTextExist = _this$state.isTextExist,
        isContentHasBigImages = _this$state.isContentHasBigImages,
        showLessonReviewModal = _this$state.showLessonReviewModal,
        isSourcesExist = _this$state.isSourcesExist,
        sourcesHTML = _this$state.sourcesHTML;
      var showContentInColumn = contentLength > 450 || isContentHasBigImages;
      return /*#__PURE__*/_jsx("div", {
        className: classNames(s.lessonContainer, _defineProperty({}, s.showContentInColumn, showContentInColumn))
      }, void 0, !!_.get(lesson, 'audios.length') && _.get(lesson, '_id') === _.get(lessonItem, '_id') && _.get(lessonItem, '_id') === openedPodcastLesson && /*#__PURE__*/_jsx(Audio, {
        complete: this.completeOnce,
        podcastAudioContentClass: classNames(s.podcastAudioContent, _defineProperty({}, s.showContentInColumn, showContentInColumn)),
        play: playPodcastAudio,
        setAudioEnded: this.setAudioEnded,
        goToNextLesson: goToNextLesson,
        setPlayPodcastAudio: setPlayPodcastAudio
      }, "".concat(lesson._id).concat(this.props.lessonItem._id, "_audio_block_").concat(courseWasReset)), !_.get(lesson, 'audios.length') && lesson.youtubeVideoUrl && /*#__PURE__*/_jsx("div", {
        className: s.podcastAudioContent
      }, void 0, /*#__PURE__*/React.createElement(Video, {
        complete: this.completeOnce,
        videoFullPage: false,
        videoStop: showLessonReviewModal,
        handleChangeVideoFullPage: _.noop,
        contentTypeSwitchers: {},
        query: {},
        thumbnailVimeoImg: this.state.posterVimeo,
        goToNextLesson: goToNextLesson,
        ref: function ref(_ref3) {
          // eslint-disable-next-line react/no-unused-class-component-methods
          _this2.player = _ref3 && _ref3.player;
          // eslint-disable-next-line react/no-unused-class-component-methods
          _this2.updateVideoNotes = _ref3 && _ref3.toggleNotes;
        },
        className: s.video,
        isLessonReviewFocused: showLessonReviewModal,
        key: "video-".concat(lesson._id)
      })), /*#__PURE__*/_jsx("div", {
        className: classNames(s.contentContainer, _defineProperty({}, s.showContentInColumn, showContentInColumn || isPodcastLessonMissingAudio(lesson)))
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: classNames(_defineProperty({}, s.showContentInColumn, showContentInColumn))
      }, void 0, /*#__PURE__*/_jsx(LessonTextContent, {
        editorState: this.state.editorState,
        onEditorChange: this.onEditorChange,
        isTextExist: isTextExist,
        fullSize: true,
        className: s.lessonTextContent
      }, void 0, /*#__PURE__*/_jsx(LessonSources, {
        headerTitle: /*#__PURE__*/React.createElement(FormattedMessage, messages.sourcesLabel),
        isSourcesExist: isSourcesExist,
        sourcesHTML: sourcesHTML
      }))), isLoggedIn(auth) && course._id && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "sL_uv9OEpYyVIWSZI73kn",
        variant: "contained",
        color: "primary",
        id: "complete-lesson",
        className: classNames(s.tabletFullWidth, s.actionButtonWrapper, s.statusBtn, _defineProperty({}, s.completeButtonSuccess, isCompleted || lesson.isCompleted)),
        onClick: isCompleted || lesson.isCompleted ? this.showLessonReviewContent : this.completeOnce,
        size: "large"
      }, void 0, (lesson.isCompleted || isCompleted) && /*#__PURE__*/_jsx(DoneIcon, {
        className: s.buttonIcon
      }), lesson.isCompleted || isCompleted ? /*#__PURE__*/React.createElement(FormattedMessage, messages.completedBtnMsg) : '', !lesson.isCompleted && !isCompleted ? /*#__PURE__*/React.createElement(FormattedMessage, messages.completeBtnmsg) : '')), showLessonReviewModal && /*#__PURE__*/_jsx(LessonReviewModal, {
        closeLessonReviewContent: this.closeLessonReviewContent
      }));
    }
  }]);
  return CoursePodcastItem;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  course: {},
  playPodcastAudio: false,
  openedPodcastLesson: '',
  goToNextLesson: _.noop,
  cancelGoToNextLesson: _.noop
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class);
export { CoursePodcastItem as default };